/* HEJLO: measure the visible bottom consent dialog for the mobile cart.
   Layout only: does not read or change consent, cookies or tracking. */
(() => {
  if (document.documentElement.hasAttribute('data-hejlo-cart-gap-ready')) return;
  document.documentElement.setAttribute('data-hejlo-cart-gap-ready', 'true');
  const roots = new WeakSet();
  const dialogs = new WeakSet();
  let queued = false;
  const sizes = new ResizeObserver(schedule);
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  function update() {
    queued = false;
    let gap = 0;
    const viewportHeight = document.documentElement.clientHeight;
    for (const host of document.querySelectorAll('pandectes-cmp')) {
      const root = host.shadowRoot;
      if (!root) continue;
      if (!roots.has(root)) {
        roots.add(root);
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true });
        root.addEventListener('transitionend', schedule);
        root.addEventListener('animationend', schedule);
        root.addEventListener('close', schedule, true);
      }
      for (const dialog of root.querySelectorAll('dialog, [role="dialog"]')) {
        if (!dialogs.has(dialog)) { dialogs.add(dialog); sizes.observe(dialog); }
        const box = dialog.getBoundingClientRect();
        const style = getComputedStyle(dialog);
        if (box.width > 0 && box.height > 0 && style.display !== 'none' &&
            style.visibility !== 'hidden' && box.bottom >= viewportHeight - 24 &&
            box.top > 0 && box.top < viewportHeight) {
          gap = Math.max(gap, viewportHeight - box.top + 12);
        }
      }
    }
    const value = Math.ceil(gap) + 'px';
    if (document.documentElement.style.getPropertyValue('--hejlo-cookie-gap') !== value) {
      document.documentElement.style.setProperty('--hejlo-cookie-gap', value);
    }
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  addEventListener('resize', schedule);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
  document.addEventListener('visibilitychange', schedule);
  schedule();
})();
